import React from 'react';
import BlockUi from 'react-block-ui';
import HighlightBanner from '../../components/HighlightedBanner/HighlightBanner';
import { PlanCardsGrid } from './_components/PlanCardsGrid';
import { PlanComparisonTable } from './_components/PlanComparisonTable';
import { usePaymentPlansBootstrap } from './payment-plans.bootstrap.hook';
import '../../components/jds/jds.css';

export function PaymentPlans() {
  const {
    plans,
    loading,
    errorMessage,
    selectedIds,
    toggleSelected,
    selectedPlans,
    comparisonRows,
  } = usePaymentPlansBootstrap();

  return (
    <div className="jds-scope">
      <h1 className="jds-title-lg">Planos</h1>
      <p className="text-muted mb-10">
        Planos do JusSub e os itens incluídos em cada um.
      </p>

      {errorMessage && (
        <div className="mb-6">
          <HighlightBanner type="error">{errorMessage}</HighlightBanner>
        </div>
      )}

      <BlockUi tag="div" blocking={loading}>
        {loading && <div style={{ height: '300px' }} />}
        {!loading && (
          <>
            <PlanCardsGrid
              plans={plans}
              selectedIds={selectedIds}
              onToggleSelected={toggleSelected}
            />
            <PlanComparisonTable
              plans={selectedPlans}
              rows={comparisonRows}
              onRemovePlan={toggleSelected}
            />
          </>
        )}
      </BlockUi>
    </div>
  );
}
